import { observer } from 'mobx-react-lite'
import { IconButton } from 'shared/ui'
import { ZIndex } from 'shared/constants/zIndex'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import styles from './styles.module.scss'

export const CallTransferPopUpButton = observer(() => {
  const store = useCallPopUpDefaultContext()
  const {
    isTransfer,
    isTransferDisabled,
    handleTransferShow,
    isTransferLoading,
    innerRefTooltipCurrent,
    isConferenceParticipants,
  } = store

  return (
    <div className={styles.wrap}>
      <IconButton
        size={'large'}
        color={'blue'}
        variant={'custom'}
        active={isTransfer}
        disabled={isTransferDisabled || isConferenceParticipants}
        loading={isTransferLoading}
        onClick={() => {
          handleTransferShow()
        }}
        spinnerLoaderProps={{
          determinatecolor: 'var(--gray-30)',
          indeterminatecolor: 'var(--gray-70)',
          ariaLabel: 'CallTransferPopUpButtonIconButton',
        }}
        iconProps={{
          icon: 'phoneTransfer',
        }}
        ariaLabel='CallTransfer_popUp'
        tooltipProps={{
          label: isTransfer ? 'Cancel' : 'Transfer call',
          placement: 'top',
          zIndex: ZIndex.OVERLAY_TOP_1,
          PopperProps: {
            popperOptions: {
              modifiers: [
                {
                  name: 'preventOverflow',
                  options: {
                    boundary: innerRefTooltipCurrent,
                  },
                },
              ],
            },
          },
        }}
      />
    </div>
  )
})
